"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isChecked = _ref.isChecked,
      onCheck = _ref.onCheck,
      onUncheck = _ref.onUncheck,
      size = _ref.size,
      style = _ref.style,
      title = _ref.title;
  return _react.default.createElement("div", {
    style: style,
    className: (0, _classnames.default)((0, _defineProperty2.default)({
      'inline-block cursor-pointer': true
    }, className, className)),
    onClick: function onClick(event) {
      isChecked ? onUncheck() : onCheck();
      event.stopPropagation();
    }
  }, _react.default.createElement("div", {
    className: "flex-row relative",
    style: {
      alignItems: !children && title && 'top'
    }
  }, _react.default.createElement(_Icon.default, {
    icon: isChecked ? 'ios-checkmark-circle' : 'ios-checkmark-circle-outline',
    style: {
      position: 'relative',
      fontSize: size ? size : '1.25em',
      marginTop: !children && title && '-0.12em'
    }
  }), children && _react.default.createElement("div", {
    style: {
      marginLeft: 3
    }
  }, children), title && _react.default.createElement("div", {
    style: {
      marginLeft: 3
    }
  }, title)));
};

Checkbox.defaultProps = {
  isChecked: false
};
var _default = Checkbox;
exports.default = _default;